<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-card styleClass="mb-3">
	<h5>Saisie des heures et KM</h5>
	<p-menubar autoDisplay="false" [model]="menu">
	</p-menubar>
</p-card>

<p-card>
	<p-tabView [scrollable]="true" #tabView [(activeIndex)]="tabIndex" orientation="left">
		<p-tabPanel header="Saisie manuelle" leftIcon="pi pi-info-circle">
			<div class="fluid formgrid grid">
				<div class="flex flex-column gap-2 my-2 col-12 lg:col-3">
					<label for="noUnite">No unité<span class="requis">*</span></label>
					<input #inputNumero type="text" pInputText id="noUnite" (keyup.enter)="validerNoItem()"
						[disabled]="heureKmManuelle" [(ngModel)]="numeroItemManuelle" autocomplete="off" />
					<small class="p-error" *ngIf="manuelleSubmitted && !numeroItemManuelle()">Le numéro est
						obligatoire.</small>
				</div>
				<div class="flex flex-column gap-2 my-2 col-12 lg:col-6">
					<label for="description">Description</label>
					<input type="text" pInputText id="description" [readonly]="true"
						[ngModel]="heureKmManuelle?.description" autocomplete="off" />
				</div>
				<div class="flex flex-column gap-2 my-2 col-12 lg:col-3">
					<label>&nbsp;</label>
					<div class="flex gap-2">
						<p-button *ngIf="!heureKmManuelle" label="Valider" [loading]="loading" (click)="validerNoItem()"
							icon="pi pi-search" iconPos="left"></p-button>
						<p-button *ngIf="heureKmManuelle" severity="success" pTooltip="Voir l'unité"
							routerLink="/item/{{heureKmManuelle.itemId}}" icon="pi pi-eye" iconPos="left"></p-button>
						<p-button *ngIf="heureKmManuelle" label="Autre Unité" (click)="annuler()"
							icon="pi pi-angle-double-left" iconPos="left"></p-button>
					</div>
				</div>



			</div>

			<p-panel *ngIf="heureKmManuelle" header="Heures" styleClass="mb-3">
				<div *ngIf="!heureKmManuelle.indApprouve" class="fluid formgrid grid">
					<div class="flex flex-column gap-2 my-2 col-12 lg:col-3">
						<label for="heuresActuelles">Dernières heures</label>
						<input type="text" pInputText id="heuresActuelles" [readonly]="true"
							[(ngModel)]="heureKmManuelle.heuresActuelles" autocomplete="off" />
					</div>
					<div class="flex flex-column gap-2 my-2 col-12 lg:col-3">
						<label for="dateHeuresActuelles">Date dernière prise</label>
						<input type="text" pInputText id="dateHeuresActuelles" [readonly]="true" readonly
							value="{{heureKmManuelle.dateHeuresActuelles | date:'yyyy-MM-dd'}}" autocomplete="off" />
					</div>
					<div class="flex flex-column gap-2 my-2 col-12 lg:col-3">
						<label for="noUnite">Date de prise des heures<span class="requis">*</span></label>
						<p-calendar appendTo="body" showIcon=true [(ngModel)]="dateHeures" dateFormat="yy-mm-dd"
							[yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"></p-calendar>
					</div>
					<div class="flex flex-column gap-2 my-2 col-12 lg:col-3">
						<label for="heures">Nouvelles heures<span class="requis">*</span></label>
						<p-inputNumber #inputHeures id="heures" [min]="0"
							[showButtons]="true" (keyup.enter)="sauvegarderHeureManuelle()" [(ngModel)]="heures"
							autocomplete="off" />
						<small class="p-error" *ngIf="heureSubmitted && !heures">Les heures sont
							obligatoires.</small>
					</div>
					<div class="flex justify-content-end gap-2 my-2 col-12">
						<p-button label="Confirmer" [disabled]="!heures" (click)="sauvegarderHeureManuelle()"
							icon="pi pi-search" iconPos="left"></p-button>
					</div>
				</div>
				<div *ngIf="heureKmManuelle.indApprouve">
					<div class="flex flex-column gap-2 my-2 col-12">
						<p-message severity="info" text="Les heures ont été saisies et sont en attente d'approbation."
							styleClass="w-full"></p-message>
					</div>
				</div>
			</p-panel>
			<p-panel *ngIf="heureKmManuelle" header="Kilomètres">
				<div *ngIf="!heureKmManuelle.indKmsApprouve" class="fluid formgrid grid">
					<div class="flex flex-column gap-2 my-2 col-12 lg:col-3">
						<label for="kmActuels">Derniers Kilomètres</label>
						<input type="text" pInputText id="kmActuels" [readonly]="true"
							[(ngModel)]="heureKmManuelle.kmActuels" autocomplete="off" />
					</div>
					<div class="flex flex-column gap-2 my-2 col-12 lg:col-3">
						<label for="dateKmsActuelles">Date dernière prise</label>
						<input type="text" pInputText id="dateKmsActuelles" [readonly]="true" readonly
							value="{{heureKmManuelle.dateKmsActuelles | date:'yyyy-MM-dd'}}" autocomplete="off" />
					</div>
					<div class="flex flex-column gap-2 my-2 col-12 lg:col-3">
						<label for="noUnite">Date de prise des KM<span class="requis">*</span></label>
						<p-calendar appendTo="body" showIcon=true [(ngModel)]="dateKms" dateFormat="yy-mm-dd"
							[yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"></p-calendar>
					</div>
					<div class="flex flex-column gap-2 my-2 col-12 lg:col-3">
						<label for="km">Nouveaux Kilomètres<span class="requis">*</span></label>
						<p-inputNumber #inputKms id="km" [min]="0" [showButtons]="true"
							(keyup.enter)="sauvegarderKmManuelle()" [(ngModel)]="kms" autocomplete="off" />
						<small class="p-error" *ngIf="kmSubmitted && !kms">Les KM sont
							obligatoires.</small>
					</div>
					<div class="flex justify-content-end gap-2 my-2 col-12">
						<p-button label="Confirmer" [disabled]="!kms" (click)="sauvegarderKmManuelle()"
							icon="pi pi-search" iconPos="left"></p-button>
					</div>
				</div>
				<div *ngIf="heureKmManuelle.indKmsApprouve">
					<div class="flex flex-column gap-2 my-2 col-12">
						<p-message severity="info" text="Les KM ont été saisies et sont en attente d'approbation."
							styleClass="w-full"></p-message>
					</div>
				</div>
			</p-panel>
		</p-tabPanel>
		<p-tabPanel header="Saisie par liste" leftIcon="pi pi-list">
			<ng-template pTemplate="content">
				<div class="fluid formgrid grid">
					<div class="flex flex-column gap-2 my-2 col-12 lg:col-4">
						<label for="dateListe">Date de prise des heures<span class="requis">*</span></label>
						<p-calendar id="dateListe" appendTo="body" showIcon="true" [(ngModel)]="dateListe"
							dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true"
							yearRange="2000:2040"></p-calendar>
					</div>
					<div class="flex flex-column gap-2 my-2 col-12 lg:col-4">
						<label for="emplacement">Emplacement</label>
						<p-dropdown id="emplacement" [options]="emplacements" [(ngModel)]="emplacement"
							optionLabel="nom" appendTo="body" filter="true" filterBy="nom, code"
							placeholder="Sélectionnez un emplacement...">
							<ng-template pTemplate="selectedItem">
								<div *ngIf="emplacement()">
									<div>{{emplacement().nom}} ({{emplacement().code}})</div>
								</div>
							</ng-template>
							<ng-template let-emplacement pTemplate="item">
								<div>
									<div>{{emplacement.nom}} ({{emplacement.code}})</div>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
					<div class="flex flex-column gap-2 my-2 col-12 lg:col-4">
						<label for="departement">Département</label>
						<p-dropdown id="departement" [options]="departements" [(ngModel)]="departement"
							optionLabel="nom" appendTo="body" filter="true" filterBy="nom"
							placeholder="Sélectionnez un département...">
							<ng-template pTemplate="selectedItem">
								<div *ngIf="departement()">
									<div>{{departement().nom}}</div>
								</div>
							</ng-template>
							<ng-template let-departement pTemplate="item">
								<div>
									<div>{{departement.nom}}</div>
								</div>
							</ng-template>
						</p-dropdown>
					</div>
				</div>

				<p-card *ngIf="!EstCharge()">
					<div class="fluid formgrid grid">
						<div class="flex flex-column gap-2 my-2 col-12 text-center">
							<p-progressSpinner></p-progressSpinner>
						</div>
					</div>
				</p-card>

				<div *ngIf="EstCharge()">
					<div class="flex justify-content-between my-3">
						<button pButton pRipple label="Réinitialiser les filtres" icon="pi pi-filter-slash"
							class="p-button-secondary" (click)="retirerFiltres()"></button>
						<p-button label="Sauvegarder" (click)="sauvegarderListe()" icon="pi pi-save"
							iconPos="left"></p-button>
					</div>
					<p-table #dtListe [value]="listeHeuresKmsFiltree" dataKey="itemId" tableStyleClass="tableMoyen"
						autoLayout="true"
						[globalFilterFields]="['numero','description', 'departement.nom', 'emplacement.nom']">
						<ng-template pTemplate="caption">
							<div class="flex align-content-center flex-wrap justify-content-between">
								<div class="flex align-items-center gap-2">
									<span class="p-input-icon-left">
										<i class="pi pi-search"></i>
										<input pInputText type="text"
											(input)="dtListe.filterGlobal($event.target.value, 'contains')"
											placeholder="Recherche..." />
									</span>
								</div>
								<div class="flex align-items-center gap-4">
									<div class="flex align-items-center gap-2 ml-2">
										<p-toggleButton [(ngModel)]="showHeures" onLabel="Heures" offLabel="Heures"
											onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
										<p-toggleButton [(ngModel)]="showKms" onLabel="Kilomètres" offLabel="Kilomètres"
											onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
									</div>
									<p-button label="Exporter" (click)="exporter()" icon="pi pi-file-pdf"
										[outlined]="true" iconPos="left"></p-button>
								</div>
							</div>
						</ng-template>

						<ng-template pTemplate="header">
							<tr>
								<th>Unité</th>
								<th>Description</th>
								<th>Département</th>
								<th>Emplacement</th>
								<th *ngIf="showHeures">Dernières heures</th>
								<th *ngIf="showHeures">Nouvelles heures</th>
								<th *ngIf="showKms">Derniers Kms</th>
								<th *ngIf="showKms">Nouveaux Kms</th>
								<th></th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-entree>
							<tr>
								<td><a (click)="afficherUnite(entree.itemId)">{{entree.numero}}</a></td>
								<td>{{entree.description}}</td>
								<td>{{entree.departement}}</td>
								<td>{{entree.emplacement}}</td>
								<td *ngIf="showHeures">
									<div class="flex flex-column align-items-center gap-2">
										<div *ngIf="entree.heuresActuelles">{{entree.heuresActuelles}}h</div>
										<div class="text-xs">{{entree.dateHeuresActuelles | date:'yyyy-MM-dd'}}</div>
									</div>
								</td>
								<td *ngIf="showHeures">
									@defer (on viewport) {
										<p-inputNumber *ngIf="!entree.indApprouve"
											[(ngModel)]="entree.heures"></p-inputNumber>
									} @placeholder {
										<div class="text-center">Chargement...</div>
									}
									<p-messages *ngIf="entree.indApprouve" severity="warn">
										<ng-template pTemplate>
											<div class="ml-2">En approbation</div>
										</ng-template>
									</p-messages>
								</td>
								<td *ngIf="showKms">
									<div class="flex flex-column align-items-center gap-2">
										<div *ngIf="entree.kmsActuelles">{{entree.kmsActuelles}}km</div>
										<div class="text-xs">{{entree.dateKmsActuelles | date:'yyyy-MM-dd'}}</div>
									</div>
								</td>
								<td *ngIf="showKms">
									@defer (on viewport) {
										<p-inputNumber *ngIf="!entree.indKmsApprouve"
											[(ngModel)]="entree.kms"></p-inputNumber>
									} @placeholder {
										<div class="text-center">Chargement...</div>
									}
									<p-messages *ngIf="entree.indKmsApprouve" severity="warn">
										<ng-template pTemplate>
											<div class="ml-2">En approbation</div>
										</ng-template>
									</p-messages>
								</td>
								<td class="erreurLigneHeure">{{entree.erreur}}</td>
							</tr>
						</ng-template>
					</p-table>

					<div class="flex justify-content-end my-2">
						<p-button label="Sauvegarder" (click)="sauvegarderListe()" icon="pi pi-save"
							iconPos="left"></p-button>
					</div>
				</div>
			</ng-template>
		</p-tabPanel>
	</p-tabView>
</p-card>